import { render, staticRenderFns } from "./PersonalIDImage.vue?vue&type=template&id=1823d82c&scoped=true"
import script from "./PersonalIDImage.vue?vue&type=script&lang=js"
export * from "./PersonalIDImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823d82c",
  null
  
)

export default component.exports